// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xvku4{overflow:hidden;position:relative}.hD2x0{position:absolute;top:0;left:0;right:0;z-index:10}.K8gMW{position:absolute;top:64px;left:0;right:0;padding:8px;z-index:10}.VGPmv{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0}.z08Uv{padding-top:64px;padding-bottom:72px}.x4mPS{padding-top:64px;padding-bottom:40px}.pBcSr{position:absolute;bottom:0;left:0;right:0;z-index:10}.wCnhR{position:absolute;top:12px;right:8px;width:200px;max-height:calc(100% - 24px);overflow-y:auto;z-index:15}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBox": `xvku4`,
	"headerWrapper": `hD2x0`,
	"titleWrapper": `K8gMW`,
	"contentArea": `VGPmv`,
	"contentAreaOnboarding": `z08Uv`,
	"contentAreaNoFooter": `x4mPS`,
	"footerWrapper": `pBcSr`,
	"setupBrandContainer": `wCnhR`
};
export default ___CSS_LOADER_EXPORT___;
